import React from "react";
import { object, bool, number, array, string } from "prop-types";
import { Link } from "@quintype/components";
import get from "lodash/get";
import { connect } from "react-redux";

import CardImage from "../../atoms/CardImage";
import Headline from "../../atoms/Headline";
import { getExcerpt, getHeadline } from "../../utils/utils";
import StoryMetaData from "../StoryMetaData";

import "./customStoryCard2.m.css";

const CustomStoryCard2 = ({
  story,
  isMetaDataShown = true,
  headlineLevel = 2,
  headlineType = 10,
  excerptLevel = 4,
  subHeadlineType = 6,
  isImageCaptionRequired = true,
  widths = [250, 480, 764],
  imageType = "image3x2",
  aspectRatio = [3, 2],
  showHeroImage = true,
  className = "",
  isSubheadline = true,
  isExcerpt = false,
  isSection = false,
  darkTheme = false,
  largeIcon = false,
  publisherAttributes,
  updatedFont = false,
  src = "",
  captionStyle = "",
  updateSubHeadline = false,
  isSmallCard = false,
  updateSectionFont = false
}) => {
  const { subheadline } = story;

  const imageCaption = () => {
    if (get(story, ["alternative", "home", "default", "hero-image", "hero-image-caption"])) {
      return get(story, ["alternative", "home", "default", "hero-image", "hero-image-caption"]);
    } else if (get(story, ["hero-image-caption"])) {
      return get(story, ["hero-image-caption"]);
    } else return null;
  };

  const imageAttribute = () => {
    if (get(story, ["alternative", "home", "default", "hero-image", "hero-image-attribution"])) {
      return get(story, ["alternative", "home", "default", "hero-image", "hero-image-attribution"]);
    } else if (get(story, ["hero-image-attribution"])) {
      return get(story, ["hero-image-attribution"]);
    } else return null;
  };

  const storyHeadline = getHeadline(story);

  const storyHeadlineStyle = updatedFont ? `${publisherAttributes.lang}-story-headline` : "";
  const storyExcerptStyle = updatedFont ? `${publisherAttributes.lang}-story-excerpt` : "";
  const storySubHeadlineStyle = updatedFont ? `${publisherAttributes.lang}-sub-headline` : "";

  const customStoryHeadlineStyle = updatedFont && src ? `${publisherAttributes.lang}-story-headline-${src}` : "";
  const customStoryExcerptStyle = updatedFont && src ? `${publisherAttributes.lang}-story-excerpt-${src}` : "";
  const customStorySubHeadlineStyle =
    updatedFont && updateSubHeadline && src ? `${publisherAttributes.lang}-sub-headline-${src}` : "";

  const headlineStyle = src ? customStoryHeadlineStyle : storyHeadlineStyle;
  const storyCardHeadlineStyle = isSmallCard
    ? `${publisherAttributes.lang}-small-story-headline-${src}`
    : headlineStyle;
  const excerptStyle = src ? customStoryExcerptStyle : storyExcerptStyle;
  const subHeadlineStyle = updateSubHeadline && src ? customStorySubHeadlineStyle : storySubHeadlineStyle;

  const excerpt = getExcerpt(story);
  const section = get(story, ["sections", "0"], null);
  const defaultCaptionStyle = captionStyle ? `${publisherAttributes.lang}-default-caption-style` : "";
  const sectionStyle = updateSectionFont ? `${publisherAttributes.lang}-section-style` : "";

  return (
    <div styleName="base" className={`custom-story-card-2  ${className}`} data-testid="stories-14">
      <div styleName="story-data" className="story-data">
        {isSubheadline && subheadline ? (
          <Link href={story.url}>
            <Headline text={subheadline} headerLevel={3} className="section-name" styleName={subHeadlineStyle} />
          </Link>
        ) : null}
        <Link href={story.url}>
          <Headline
            text={storyHeadline}
            headerLevel={headlineLevel}
            headlineType={headlineType}
            className="story-headline"
            styleName={storyCardHeadlineStyle}
          />
        </Link>
        {isExcerpt && excerpt ? (
          <Link href={story.url}>
            <Headline
              text={excerpt}
              headerLevel={excerptLevel}
              headlineType={subHeadlineType}
              className="sub-headline"
              styleName={excerptStyle}
            />
          </Link>
        ) : null}
        {isMetaDataShown ? (
          <StoryMetaData story={story} updatedFont={updatedFont} publisherLang={publisherAttributes.lang} src={src} />
        ) : null}
      </div>
      <div className="image-view">
        {showHeroImage && (
          <Link href={story.url}>
            <CardImage
              story={story}
              aspectRatio={aspectRatio}
              imageType={imageType}
              widths={widths}
              showAlternateImage={true}
              darkTheme={darkTheme}
              largeIcon={largeIcon}
            />
            {isSection && section && (
              <Link href={section["section-url"]}>
                <div className="display-section" styleName={sectionStyle}>
                  {section["display-name"]}
                </div>
              </Link>
            )}
          </Link>
        )}
        {isImageCaptionRequired && imageCaption() && (
          <div
            styleName={`image-attribute ${
              publisherAttributes.lang === "en" ? "en-image-attribute" : ""
            } ${defaultCaptionStyle}`}
            className="image-attribute"
          >
            {imageCaption()}
            {imageAttribute() && <span styleName="atrribute">: {imageAttribute()}</span>}
          </div>
        )}
      </div>
    </div>
  );
};

CustomStoryCard2.propTypes = {
  story: object.isRequired,
  isMetaDataShown: bool,
  headlineLevel: number,
  headlineType: number,
  subHeadlineType: number,
  isImageCaptionRequired: bool,
  widths: array,
  imageType: string,
  aspectRatio: array,
  showHeroImage: bool,
  isTag: bool,
  className: string,
  isSubheadline: bool,
  excerptLevel: number,
  isExcerpt: bool,
  isSection: bool,
  darkTheme: bool,
  largeIcon: bool,
  publisherAttributes: object,
  updatedFont: bool,
  src: string,
  captionStyle: string,
  updateSubHeadline: bool,
  isSmallCard: bool,
  updateSectionFont: bool
};

const mapStateToProps = state => {
  return {
    publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {})
  };
};

export default connect(mapStateToProps, null)(CustomStoryCard2);
